/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdvancedKeywordSearchResponseDto } from '../models/advanced-keyword-search-response-dto';
import { getNestedAggs } from '../fn/data-mart-advanced-search/get-nested-aggs';
import { GetNestedAggs$Params } from '../fn/data-mart-advanced-search/get-nested-aggs';
import { getProfileIndexKeywordValues } from '../fn/data-mart-advanced-search/get-profile-index-keyword-values';
import { GetProfileIndexKeywordValues$Params } from '../fn/data-mart-advanced-search/get-profile-index-keyword-values';

@Injectable({ providedIn: 'root' })
export class DataMartAdvancedSearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `advancedSearchControllerGetProfileIndexKeywordValues()` */
  static readonly AdvancedSearchControllerGetProfileIndexKeywordValuesPath =
    '/data-mart/advanced-search/{programPeriodId}/keyword/{keyword}/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileIndexKeywordValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileIndexKeywordValues$Response(
    params: GetProfileIndexKeywordValues$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AdvancedKeywordSearchResponseDto>> {
    return getProfileIndexKeywordValues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileIndexKeywordValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileIndexKeywordValues(
    params: GetProfileIndexKeywordValues$Params,
    context?: HttpContext
  ): Observable<AdvancedKeywordSearchResponseDto> {
    return this.getProfileIndexKeywordValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdvancedKeywordSearchResponseDto>): AdvancedKeywordSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `advancedSearchControllerGetNestedAggs()` */
  static readonly AdvancedSearchControllerGetNestedAggsPath = '/data-mart/advanced-search/nestedAggs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNestedAggs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNestedAggs$Response(
    params?: GetNestedAggs$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AdvancedKeywordSearchResponseDto>> {
    return getNestedAggs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNestedAggs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNestedAggs(params?: GetNestedAggs$Params, context?: HttpContext): Observable<AdvancedKeywordSearchResponseDto> {
    return this.getNestedAggs$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdvancedKeywordSearchResponseDto>): AdvancedKeywordSearchResponseDto => r.body)
    );
  }
}
